export const FEET_PER_MILE = 5280;
export const FEET_PER_METER = 3.2808399;

export function metresToFeet(metres: number): number {
    return metres * FEET_PER_METER;
}

export function celsiusToFahrenheit(celsius: number): number {
    return celsius * 1.8 + 32;
}
